export default __webpack_public_path__ + "static/buildTrust-47e6c912ff8bf92f5b4ba1a857263957.png";